export default {"src":"/_next/static/media/operational.f3970058.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};